
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class InputBase extends Vue {
  @Prop() label?: string;
  @Prop() labelFor?: string;
  @Prop({ default: false }) hasError?: boolean;
  @Prop() helpText?: string;
  @Prop(String) errId!: string;
}
